import { render, staticRenderFns } from "./RentsPerUserReport.vue?vue&type=template&id=625e5982"
import script from "./RentsPerUserReport.vue?vue&type=script&lang=js"
export * from "./RentsPerUserReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports